export default __webpack_public_path__ + "static/media/iconStarDark.c1763f1c.svg";